import React from 'react'
import ActionColumnRenderer from '../../../app/Table/renderer/ActionColumnRenderer'
import Hospital from '../../../../models/Hospital'

export default class HospitalColumnRenderer extends ActionColumnRenderer<Hospital> {

  getColumns() {
    return [
      {
        name: 'Name',
        selector: 'name',
      },

      {
        name: 'State',
        selector: 'state',
      },

      {
        name: 'District',
        selector: 'district',
      },

      {
        name: 'Pincode',
        selector: 'pinCode',
        cell: (row: Hospital) => row.getPinCode(),
      },

      {
        name: 'Merge',
        selector: 'merged',

        cell: (row: any) => {
          const merged = row.getMergeStatus() === true
          return React.createElement(
            'span',
            {
              style: {
                display: 'inline-block',
                backgroundColor: merged ? '#21ba45' : '#e0e0e0',
                color: merged ? '#ffffff' : '#555555',
                padding: '4px 10px',
                borderRadius: '12px',
                fontSize: '12px',
                fontWeight: 600,
              },
            },
            merged ? 'Merged' : 'Not Merged'
          )
        },
      },

      {
        name: 'Actions',
        selector: 'id',
        grow: 0,
        width: '300px',
        cell: this.renderActionColumn,
      },
    ]
  }
}